module.exports = __webpack_public_path__ + "static/media/accredited-business.ee4196ef.webp";